import { getBodyAdjusterImagesTabsQueryFunction } from '@/modules/adjusterReportModules/Insurer-information/queries/getBodyDamagedAdjusterImagesTabs/getBodyAdjusterImagesTabsQueryFunction';
import { GetBodyAdjusterImagesTabsQueryParamsType } from '@/modules/adjusterReportModules/Insurer-information/queries/getBodyDamagedAdjusterImagesTabs/getBodyDamagedAdjusterImagesTabs.type';
import { queryOptions } from '@tanstack/react-query';

export const getBodyAdjusterImagesTabsOptions = (
  params: GetBodyAdjusterImagesTabsQueryParamsType,
) => {
  return queryOptions({
    queryKey: ['GET_BODY_ADJUSTER_IMAGE_TABS', params],
    queryFn: () => getBodyAdjusterImagesTabsQueryFunction(params),
  });
};
